import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { STATUS_TOOLTIPS } from '../constants';
import type { RecipientStatus } from '../types';
import { InfoTooltip } from './InfoTooltip';

interface RecipientStatusBadgeProps {
  status: RecipientStatus;
}

export const RecipientStatusBadge: React.FC<RecipientStatusBadgeProps> = ({
  status,
}) => {
  const isPending = status === 'pendente';

  return (
    <Badge
      className={cn(
        'rounded-full border-transparent font-medium px-2.5 py-[3px] gap-1',
        isPending
          ? 'bg-amber-100 text-amber-800 hover:bg-amber-100'
          : 'bg-green-50 text-green-700 hover:bg-green-50'
      )}
    >
      <InfoTooltip
        text={isPending ? STATUS_TOOLTIPS.pendente : STATUS_TOOLTIPS.ativo}
        iconClassName={isPending ? 'text-amber-800' : 'text-green-600'}
      />
      {isPending ? 'Pendente' : 'Ativo'}
    </Badge>
  );
};
